
define('text!modules/map/map_player_item_template.html',[],function () { return '<a><img src="<%- preview %>" data-id="<%- id %>" class="player-link map-player" style="top: <%- position_top %>%; left: <%- position_left %>%;"></a>\r\n';});

